import { useContext, useEffect, useMemo, useState } from 'react';

import AccountPickerContext from 'contexts/AccountPickerContext';
import STORE from 'store';

// Listens to a bonus program's override-visibility settings and returns the set
// of reward `name`s that should be hidden while override mode is active. Returns
// an empty set until the snapshot resolves (and when none are configured, which
// is the default — every reward stays visible).
const useHiddenOverrideRewardNames = ({
  bonusProgramId,
}: {
  bonusProgramId: string;
}) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [hiddenRewardNames, setHiddenRewardNames] = useState<string[]>([]);

  useEffect(() => {
    let isActive = true;
    const unsubscribe = STORE.bonus
      .getBonusOverrideSettingsRef({
        accountId: selectedAccountId,
        bonusProgramId,
      })
      .onSnapshot((snapshot) => {
        if (!isActive) {
          return;
        }
        setHiddenRewardNames(snapshot.data()?.hiddenRewardNames ?? []);
      });

    return () => {
      isActive = false;
      unsubscribe();
    };
  }, [bonusProgramId, selectedAccountId]);

  return useMemo(() => new Set(hiddenRewardNames), [hiddenRewardNames]);
};

export default useHiddenOverrideRewardNames;
